import CompanyExpiredDateDialog from "./company-expired-date-dialog.container";

export default CompanyExpiredDateDialog;
